import { Box, Typography } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';

function Service({ icon, title, desc, path }) {
  const navigate = useNavigate();
  return (
    <Box
      sx={{ color: 'white', display: 'flex' }}
      className={'service-card'}
      onClick={() => {
        navigate(path);
      }}>
      <Box
        sx={{
          p: 1,
          border: '1px solid #f9fdfc',
          padding: '1rem 1rem',
          background: '#f9fdfc',
        }}>
        <Box
          display={'flex'}
          justifyContent={'space-between'}
          alingItems={'center'}
          sx={{ my: 2 }}>
          <Typography textAlign={'center'} variant="h5" color="text.primary">
            {title}
          </Typography>
          {icon}
        </Box>

        <Typography textAlign={'center'} variant="caption" color="text.primary">
          {desc}
        </Typography>
      </Box>
    </Box>
  );
}

export default Service;
